import { useState } from 'react'

/**
 * Hook for managing the validation errors modal
 */
const useValidationErrorsModal = () => {
  const [visible, setVisible] = useState<boolean>(false)

  return {
    visible,
    show: () => setVisible(true),
    hide: () => setVisible(false)
  }
}

export default useValidationErrorsModal 